const WEXHelper = {
    changeTab: function (tabname) {
        if($('#tab_field').length > 0){
            document.getElementById('tab_field').value = tabname;
        }
    },
    changeStep: function (openNames, open, closedNames) {
        document.getElementById(open + '-tab').className = 'nav-link active';
        document.getElementById(open).className = 'tab-pane fade show active';
        for(var i=0; i<openNames.length; i++){
            document.getElementById(openNames[i] + '-tab').className = 'nav-link active';
            document.getElementById(openNames[i]).className = 'tab-pane fade';
        }
        for(var i=0; i<closedNames.length; i++){
            document.getElementById(closedNames[i] + '-tab').className = 'nav-link';
            document.getElementById(closedNames[i]).className = 'tab-pane fade';
        }
    },
    unDropMenu: function(buttonName, menuName){
        var button = document.getElementById(buttonName);
        var open = button.name == buttonName;
        if(open){
            button.name = buttonName + 'Open';
            button.innerHTML = '<i class="fa fa-chevron-down" aria-hidden="true"></i>';
            var collection = document.getElementsByName(menuName);
            for (var i=0; i<collection.length; i++) {
                collection[i].style.display = 'list-item';
            }
        } else {
            button.name = buttonName;
            button.innerHTML = '<i class="fa fa-chevron-up" aria-hidden="true"></i>';
            var collection = document.getElementsByName(menuName);
            for (var i=0; i<collection.length; i++) {
                collection[i].style.display = 'none';
            }
        }
    }
}

module.exports = WEXHelper;